import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/ro.ts
var add = "Adăugare";
var remove = "Elimină";
var removeAll = "Elimină tot";
var incomplete = "Pare rău, unele câmpuri nu sunt corect completate.";
var submit = "Trimite";
var noFiles = "Nu este selectat nici un fișier";
var moveUp = "Mutare în sus";
var moveDown = "Mutare în jos";
var isLoading = "Se încarcă...";
var loadMore = "Încărcați mai mult";
var next = "Urmatorul";
var prev = "Precedent";
var addAllValues = "Adăugați toate valorile";
var addSelectedValues = "Adăugarea valorilor selectate";
var removeAllValues = "Eliminați toate valorile";
var removeSelectedValues = "Eliminați valorile selectate";
var chooseDate = "Alege data";
var changeDate = "Modificați data";
var close = "Închide";
var open = "Deschis";
var accepted = function({
  name
}) {
  return `Te rog acceptă ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} trebuie să fie după ${date(args[0])}.`;
  }
  return `${sentence(name)} trebuie sa fie în viitor.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} poate conține doar caractere alafetice.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} poate conține doar litere și numere.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} poate conține doar litere și spații.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} trebuie să conțină caractere alfabetice.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} trebuie să conțină litere sau numere.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} trebuie să conțină litere sau spații.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} trebuie să conțină simbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} trebuie să conțină majuscule.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} trebuie să conțină litere mici.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} trebuie să conțină numere.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} trebuie să fie un simbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} poate conține doar litere mari.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} poate conține doar litere mici.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} trebuie să preceadă ${date(args[0])}.`;
  }
  return `${sentence(name)} trebuie să fie în trecut.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Câmpul a fost configurat incorect și nu poate fi trimis.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} trebuie să fie între ${a} și ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} nu se potrivește.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nu este validă, te rog foloște formatul ${args[0]}`;
  }
  return "Câmpul a fost incorect configurat și nu poate fi trimis.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} trebuie să fie între ${date(args[0])} și ${date(args[1])}`;
};
var email = "Te rog folosește o adresă de email validă.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} nu se termină cu ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} nu este o valoare acceptată.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} trebuie sa conțină cel puțin un caracter.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} trebuie sa aibă cel mult ${max2} caractere.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} ar trebui să aibă ${max2} caractere lungi.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} trebuie să aibă cel puțin ${min2} caractere.`;
  }
  return `${sentence(name)} trebuie să aibă între ${min2} și ${max2} caractere.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} nu este o valoare acceptată.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nu poate avea mai mult decat ${args[0]} ${name}.`;
  }
  return `${sentence(name)} trebuie să fie cel mult egal cu ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Tipul de fișier neacceptat.";
  }
  return `${sentence(name)} trebuie să fie de tipul: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nu poate avea mai puțin decât ${args[0]} ${name}.`;
  }
  return `${sentence(name)} trebuie să fie cel puțin ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” nu este o valoare acceptă pentru ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} trebuie să fie un număr.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" sau ")} este necesar.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} este necesar.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} nu începe cu ${list(args)}.`;
};
var url = function() {
  return `Introduceți o adresă URL validă.`;
};
var invalidDate = "Data selectată este nevalidă.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var ro_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, ro_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=ro.mjs.map